<template>
  <div class="row container--stretch m-n">
    <div class="col-md-2 col-sm-3 hidden-xs no-padder left bg-grey">
      <div class="container-fluid p-y">
        <div>
          <team></team>
        </div>
        <div>
          <articles></articles>
        </div>
        <div v-if="this.$store.getters.isStoreAvailable">
          <products></products>
        </div>
      </div>
    </div>
    <div class="col-md-10 col-sm-9 no-padder">
      <div class="container-fluid p-y">
        <div class="events-page-header m-t-0 m-b-sm b-n">
          <h1 class="m-n text-center text-u-c">Events</h1>
          <div v-if="isOwner" class="pull-right m-t-n-lg">
            <button @click="goEventAdd()" type="button" class="btn btn-default btn-circle"><i class="glyphicon glyphicon-plus"></i></button>
          </div>
        </div>
        <hr style="width: 100%;">

        <div v-if="empty" class="text-center text-muted" style="margin-top: 40px; font-style: italic; text-transform: lowercase;">no items found</div>
        <div class="event-content">
          <div class="event-block" v-for="event in events">
            <event :event="event"></event>
          </div>
        </div>
        <div v-if="loader">
          <pre-loader></pre-loader>
        </div>
        <div class="down-button-wrapper" v-if="!busy && !loader" @click="onScroll()">
          <img class="down-button" src="/vue-app/assets/img/down-arrow.svg">
        </div>

        <div class="col-xs-12 hidden-lg hidden-md hidden-sm no-padder">
          <div class="container-fluid p-y">
            <div class="item">
              <team></team>
            </div>
            <div class="item">
              <articles></articles>
            </div>
            <div v-if="this.$store.getters.isStoreAvailable" class="item">
              <products></products>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import snapshot from '../../components/about/snapshot';
  import articles from '../../components/left-side/articles';
  import contact from '../../components/left-side/contact';
  import affiliates from '../../components/left-side/affiliations';
  import products from '../../components/left-side/products';
  import team from '../../components/left-side/team';
  import event from '../../components/event/event';
  import ApiService from "../../../../services/ApiService";

  export default {
    components: {
      snapshot, contact, affiliates, products, team, event, articles
    },
    data() {
      return {
        loader: false,
        apiService: new ApiService(),
        busy: false,
        isOwner: false,
        empty: false,
        events: null,
        perPage: 9,
        page: 1
      }
    },
    created() {
      this.getEvents();
      this.defineOwner();
    },
    computed:{
      profile(){
        return this.$store.getters.profile;
      }
    },
    methods: {
      defineOwner() {
        this.isOwner = this.profile.profile_id === window.user.profile_id;
      },
      getEvents(merge = false) {
        if(!this.busy && !this.loader) {
          this.loader = true;
          this.apiService.get(`/event?profile_id=${this.profile.profile_id}&community_id=${window.user.community_id}&page=${this.page}&per-page=${this.perPage}&expand=owner,city,country`)
            .then(res => {
              res.items.map(e => {
                e.avatar = this.addAWS(e.avatar);
              });
              this.busy = res._meta.currentPage >= res._meta.pageCount;
              this.empty = res._meta.totalCount == 0;
              if(merge) {
                this.events = this.events.concat(res.items);
              } else {
                this.events = res.items;
              }
              this.loader = false;
            })
        }
      },
      onScroll() {
        this.page++;
        this.getEvents(true);
      },
      addAWS(url) {
        if (!/^(f|ht)tps?:\/\//i.test(url)) {
          url =  process.env.AWS_URL + "/" + url;
        }
        return url;
      },
      goEventAdd(){
        window.location.assign(`${window.user.community_url}/${window.user.community_domain}/default/events/create`);
      }
    }
  }
</script>

<style lang="scss">
  .lazy-image-placeholder {
    background-position: center center;
    background-repeat: no-repeat;
    background-size: auto;
  }
  .lazy-image {
    max-width: 100% !important;
  }
  .events-page-header {
    margin-top: 17px;
    margin-bottom: 10px;
  }
  .events-page-header h1 {
    font-style: normal;
    color: #000;
    font-weight: 300;
    font-size: 20px;
    line-height: 23px;
    text-align: center;
    letter-spacing: 0.72px;
  }
  .event-content {
    display: flex;
    flex-wrap: wrap;
    align-items: start;
    justify-content: center;
    flex-direction: row;
  }
  .event-block {
    display: block;
    margin: 10px 20px;
    width: 300px;
    height: 330px;
    background-color: #fff;
    cursor: pointer;
  }
  .down-button {
    cursor: pointer;
    width: 32px;
    margin-left: calc(50% - 16px);
  }
  @media only screen and (min-width: 1201px) {
    .events-page-header h1 {
      font-size: 24px;
      line-height: 28px;
    }
  }
  @media only screen and (max-width: 1200px) and (min-width: 1024px) {
    .events-page-header h1 {
      font-size: 20px;
      line-height: 23px;
    }
    .event-block {
      width: 200px;
    }
  }
  @media only screen and (max-width: 1023px) and (min-width: 768px) {
    .events-page-header h1 {
      font-size: 20px;
      line-height: 23px;
    }
    .event-block {
      width: 224px;
    }
  }
  @media only screen and (max-width: 767px) {
    .events-page-header h1 {
      font-size: 20px;
      line-height: 23px;
    }
  }
</style>
